import styled from 'styled-components'

export const Container = styled.main`
  margin: 0 10px;
  display: inline-flex;
`
